<!--引导页-->
<template>
  <el-dialog title="场景类案例操作指引说明" class="addDialog" :visible.sync="Visible" width="900px" :show-close="false"
             :close-on-press-escape="false" :close-on-click-modal="false">
    <div class="content-inner">
      <div class="l-inner">
        <div class="item">
          <div class="label-inner">1、先体验测试智能场景的完整功能 Ps：完整功能由系统内置，仅供体验</div>
          <!-- <p>这里放gif图</p> -->
          <div class='img-inner'>
            <img src="~@imgs/case/1.gif" />
          </div>
        </div>
        <div class="item">
          <div class="label-inner">二、点击<span style="color: #ff6339;">返回Dygpt</span>按钮，根据<span
                  style="color: #ff6339;">案例描述</span>，复现搭建相应的工作流</div>
          <!-- <p>这里放gif图</p> -->
          <div class='img-inner'>
            <img src="~@imgs/case/2.gif" />
          </div>
        </div>
        <div class="item">
          <div class="label-inner">
            三、工作流搭建完成并保存后，获取并<span style="color: #ff6339;">复制工作流API</span>，返回场景页面<span style="color: #ff6339;">进行API配置</span>
          </div>
          <div class='img-inner'>
            <img src="~@imgs/case/3.gif" />
          </div>
        </div>
        <div class="item">
          <div class="label-inner">四、配置完成后，测试功能是否满足案例要求即可交卷</div>
          <div class='img-inner'>
            <img src="~@imgs/case/4.gif" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer-inner" slot="footer">
      <el-button type="primary" size="small" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'guideDialog',
  data () {
    return {
      Visible: false,
      Form: {

      },
    }
  },
  computed: {
  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    show () {
      this.Visible = true
    },

    handleClose () {
      this.Visible = false
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
.addDialog {
  backdrop-filter: blur(5px);

  /deep/ .el-dialog {
    border: 1px solid rgba(29, 156, 181, 0.3);
    padding: 0 20px;
    border-radius: 10px;
    background-color: #fff;

    .el-dialog__headerbtn {
      font-size: 20px !important;
    }
  }
 
  .content-inner {
    height: 500px;
    overflow: auto;

    .label-inner {
      color: #fff;
      margin-bottom: 12px;
      font-size: 16px;
      user-select: none;
    }

    .img-inner {
      width: 100%;
      height: auto;
      padding: 10px;
      box-sizing: border-box;
      border: 1px solid rgba(255, 255, 255, 0.6);

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .l-inner {
      // float: left;
      // width: 53%;
      // margin-right: 30px;
      width: 100%;
    }

    .item {
      margin-bottom: 30px;
      padding: 0 10px;

      /deep/ textarea {
        resize: none;
      }

      .play-icon {
        margin-left: 15px;
        cursor: pointer;
        color: #0f99cb;

        &::before {
          font-size: 20px;
          margin-right: 2px;
          vertical-align: middle;
        }

        &:hover {
          color: #1e589f;
        }
      }
    }

  }

  .footer-inner {
    text-align: center;

    .el-button {
      min-width: 120px;
      letter-spacing: 2px;
    }
  }
}

/**
 * -------------------------------------------------------
 * 滚动条
 * -------------------------------------------------------
 */
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  box-shadow: inset 0 0 10px -2px #ffffff;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  /*background: #ddd;*/
}
</style>